import $ from 'jquery';

export const localizeRulerControls = (observerKey = 'rulerObserver') => {
  if (window[observerKey]) return;

  const replaceTitles = () => {
    $('.ymaps3--default-ruler-point_actions button').each((_, btn) => {
      const $btn = $(btn);

      if ($btn.attr('title') === 'Remove all points') {
        $btn.attr('title', 'Удалить точки');
      }

      if ($btn.attr('title') === 'Finish editing the ruler') {
        $btn.attr('title', 'Завершить редактирование');
      }
    });
  };

  replaceTitles();

  window[observerKey] = new MutationObserver(() => {
    replaceTitles();
  });

  window[observerKey].observe(document.body, {
    childList: true,
    subtree: true,
  });
};
